import React, { useRef } from 'react'
import { PageContext } from 'types/PageContext'
import { preloadLists } from 'modules/member/lists/queries/useLists'
import { BrandCarouselCategories } from './components/BrandCarouselCategories'
import { BrandCarouselItemList } from './components/BrandCarouselItemList'
import { BrandCarouselProvider } from './context/BrandCarouselContext'
import { queryBrandsDiscoveryWithClient } from './queries/getDiscoveryBrands'

const LIST_IDS = [
  '262009', // Ceramic dreams
  '352321', // Upcoming thingdrops
  '262021', // Independent designers
  '351648', // Scents & smells
  '391259', // Be among the first to review...
  '352224' // Recently launched
]

export const BrandCarousel = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null)

  const onFilter = () => {
    scrollRef.current?.scrollTo(0, 0)
  }

  return (
    <section>
      <BrandCarouselProvider listIds={LIST_IDS} onFilter={onFilter}>
        <BrandCarouselCategories />
        <BrandCarouselItemList ref={scrollRef} />
      </BrandCarouselProvider>
    </section>
  )
}

BrandCarousel.getInitialProps = async ({ apolloClient }: PageContext) => {
  return Promise.all([preloadLists({ apolloClient, listIds: LIST_IDS }), queryBrandsDiscoveryWithClient(apolloClient, { includePromotions: true })])
}
